<template>
  <div class="row">

    <!-- 🔹 COLONNE GAUCHE : LISTE -->
    <div class="col-md-4 border-end">

      <h5 class="mb-3">Équipe du projet</h5>

      <input
          type="text"
          class="form-control mb-3"
          placeholder="Rechercher"
          v-model="search"
      />

      <button
          type="button"
          v-if="!viewMode"
          class="btn btn-primary w-100 mb-3"
          @click="createNew"
      >
        <i class="fe fe-plus me-1"></i>
        Ajouter un membre
      </button>

      <div
          v-for="(member, index) in filteredMembers"
          :key="index"
          class="card mb-2 cursor-pointer"
          :class="{ 'bg-primary-transparent': selectedIndex === index }"
          @click="select(index)"
      >
        <div class="card-body p-3">
          <strong>{{ member.fullName || 'Sans nom' }}</strong>
          <div class="text-muted small">
            {{ member.role || '—' }}
          </div>
        </div>
      </div>

    </div>

    <!-- 🔹 COLONNE DROITE : DÉTAIL -->
    <div class="col-md-8">

      <h5 class="mb-4">Détail du membre</h5>

      <div v-if="selectedIndex === null" class="text-muted">
        Sélectionnez un membre à gauche
      </div>

      <div v-else>

        <!-- ACTIONS -->
        <div class="d-flex justify-content-end gap-2 mb-4">
          <button
              type="button"
              v-if="editMode"
              class="btn btn-outline-secondary"
              @click="cancelEdit"
          >
            Ignorer
          </button>

          <button
              type="button"
              v-if="editMode"
              class="btn btn-primary"
              @click="apply"
          >
            Valider
          </button>

          <button
              type="button"
              v-if="!editMode && !viewMode"
              class="btn btn-primary"
              @click="editMode = true"
          >
            Modifier
          </button>

          <button
              type="button"
              v-if="!viewMode"
              class="btn btn-outline-danger"
              @click="remove"
          >
            Supprimer
          </button>
        </div>

        <!-- FORM -->
        <div class="row">

          <div class="col-md-6 mb-3">
            <FieldViewEdit
                label="Nom complet"
                v-model="form.fullName"
                :viewMode="viewMode || !editMode"
                required
            />
          </div>

          <div class="col-md-6 mb-3">
            <FieldViewEdit
                label="Rôle"
                v-model="form.role"
                :viewMode="viewMode || !editMode"
            />
          </div>

          <div class="col-md-12 mb-3">
            <FieldViewEdit
                label="Expertise"
                v-model="form.expertise"
                :viewMode="viewMode || !editMode"
            />
          </div>

          <div class="col-md-12 mb-3">
            <FieldViewEdit
                label="Bio"
                type="textarea"
                v-model="form.bio"
                :viewMode="viewMode || !editMode"
            />
          </div>

          <div class="col-md-12 mb-3">
            <FieldViewEdit
                label="Lien CV"
                v-model="form.cvUrl"
                :viewMode="viewMode || !editMode"
            />
          </div>

        </div>

      </div>

    </div>

  </div>
</template>

<script>
  import FieldViewEdit from "@/components/forms/FieldViewEdit.vue";

  export default {
    name: "ProjectTeamMembers",
    components: { FieldViewEdit },
    props: {
      value: {
        type: Array,
        required: true,
      },
      viewMode: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        selectedIndex: null,
        form: {},
        editMode: false,
        search: "",
      };
    },
    computed: {
      filteredMembers() {
        return this.value.filter(m =>
            (m.fullName || "")
                .toLowerCase()
                .includes(this.search.toLowerCase())
        );
      },
    },
    methods: {
      select(index) {
        this.selectedIndex = index;
        this.form = { ...this.value[index] };
        this.editMode = false;
      },
      createNew() {
        this.selectedIndex = this.value.length;
        this.form = {
          fullName: "",
          role: "",
          expertise: "",
          bio: "",
          cvUrl: "",
        };
        this.editMode = true;
      },
      apply() {
        const updated = [...this.value];
        updated[this.selectedIndex] = { ...this.form };
        this.$emit("input", updated);
        this.editMode = false;
      },
      remove() {
        const updated = [...this.value];
        updated.splice(this.selectedIndex, 1);
        this.$emit("input", updated);
        this.selectedIndex = null;
      },
      cancelEdit() {
        this.form = { ...this.value[this.selectedIndex] };
        this.editMode = false;
      },
    },
  };
</script>
